import React from "react";
import { Link } from "react-router-dom";
import { Info } from "lucide-react";

import { pathGenerators } from "utils/routes";

import styles from "./HealthlinkMisconfiguredNotice.module.css";

export const HealthlinkMisconfiguredNotice = () => (
  <div className={styles.notice} role="status">
    <Info className={styles.icon} size={20} aria-hidden />
    <p className={styles.message}>
      HealthLink is not configured for this practice, so vaccines cannot be
      submitted to HealthLink. You can still record vaccines manually, or{" "}
      <Link className={styles.link} to={pathGenerators.settings.healthlink()}>
        configure HealthLink
      </Link>{" "}
      for this practice.
    </p>
  </div>
);
